import Login from "./components/Login/Login";
import Registration from "./components/Registration/Registration";
import ForgotPassword from "./components/Auth/Forgotpassword";
import CreateRound from "./components/CreateRound";
import CreateDrive from "./components/CreateDrive";
import DriveEdit from "./components/Edit/DriveEdit";
import RoundsEdit from "./components/Edit/RoundsEdit";
import Dashboard from "./components/Dashboard";
import Applications from "./components/Applications";
import ViewRounds from "./components/Resource/ViewRounds";
import "bootstrap/dist/css/bootstrap.min.css";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";

import "./App.css";

import WorkflowList from "./workflow/components/workflow_list";
import WorkflowListExecutions from "./workflow/components/WorkflowListExecutions";
import ShowForm from "./workflow/components/workflow_form";

import AppContent from "./components/AppContent";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./components/Home";

import PersonalDetails from "./components/PersonalDetails";
import ParentDetails from "./components/ParentDetails";
import StudentHome from "./components/StudentHome";

// import GATEDetails from "./components/GATEDetails";
import CollegeDetails from "./components/CollegeDetails";
import EducationDetails from "./components/EducationDetails";
import Programmepreference from "./components/Programmepreference";
import PaymentInitiate from "./components/PaymentInitiate";
import Declaration from "./components/Declaration";
import PaymentStatus from "./components/PaymentStatus";

import { StudentProgressProvider } from "./context/StudentProgressContext";
import Registartion_List from "./components/Registration_List";
import ToastContainer from "./components/ToastContainer";
import NotFound from "./components/NotFound";
import Unauthorized from "./components/Unauthorized";
import Maintenance from "./components/Maintenance";
import StudentRegistrationHome from "./components/StudentRegistrationHome";
import ExamDetails from "./components/ExamDetails";
import { getConfig } from "./config/runtimeConfig";
import QueryChatPopup from "./components/QueryManager/QueryChat/QueryChatPopup";
import AllQueriesPopup from "./components/QueryManager/AllQueries/AllQueriesPopup";
import HelpQueryPopup from "./components/QueryManager/HelpQuery/HelpQueryPopup";
import MyQueriesPopup from "./components/QueryManager/MyQuery/MyQueriesPopup";
import PaymentIciciInitiate from "./components/PaymentIciciInitiate";
import PaymentIciciStatus from "./components/PaymentIciciStatus";
import DriveProtectedRoute from "./components/DriveProtectedRoute";
import BtechOnlineRound from "./components/BtechOnlineRound";
import MtechOnlineRoundDisplay from "./components/MtechOnlineRoundDisplay";
import BtechOnlineRoundDisplay from "./components/BtechOnlineRoundDisplay";
import CheckPaymentStatus from "./components/CheckPaymentStatus";
import JeeUpdate from "./components/JeeUpdate";
import WithdrawApplication from "./components/WithdrawApplication";
import Withdrawals from "./components/Withdrawals";
import UpdateStatus from "./components/UpdateStatus";

const isMaintenanceMode = getConfig().MAINTENANCE_MODE;

function App() {
  if (isMaintenanceMode) {
    return <Maintenance />;
  }

  return (
    <>
      <ToastContainer />
      <Routes>
        {/* <Route path="/workflow" element={<WorkflowList />} />

        <Route
          path="/workflow/workflow_list_executions"
          element={<WorkflowListExecutions />}
        />
        <Route
          path="/workflow/workflow_form/:execution_id"
          element={<ShowForm />}
        /> */}
        {/* <Route path="/" element={<Navigate to="/admin/login" replace />} />
        <Route path="/admin/login" element={<LoginPage />} /> */}
        <Route path="/" element={<Home />}>
          <Route path="/registration" element={<Registration />} />
          <Route path="/reset-password" element={<ForgotPassword />} />
          <Route index element={<Login />} />
        </Route>
        {/* <Route path="/admin/*" element={<AppContent />} /> */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute requiredRoles={["admin"]}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/createdrive"
          element={
            <ProtectedRoute requiredRoles={["admin"]}>
              <CreateDrive />
            </ProtectedRoute>
          }
        />
        <Route
          path="/createround"
          element={
            <ProtectedRoute requiredRoles={["admin"]}>
              <CreateRound />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit/drive/:id"
          element={
            <ProtectedRoute requiredRoles={["admin"]}>
              <DriveEdit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit/rounds/:id"
          element={
            <ProtectedRoute requiredRoles={["admin"]}>
              <RoundsEdit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/registration_list"
          element={
            <ProtectedRoute requiredRoles={["admin"]}>
              <Registartion_List />
            </ProtectedRoute>
          }
        />
        <Route
          path="/applications"
          element={
            <ProtectedRoute requiredRoles={["admin"]}>
              <Applications />
            </ProtectedRoute>
          }
        />
        <Route
          path="/viewrounds"
          element={
            <ProtectedRoute requiredRoles={["admin"]}>
              <ViewRounds />
            </ProtectedRoute>
          }
        />
        <Route
          path="/viewrounds/:type"
          element={
            <ProtectedRoute requiredRoles={["admin"]}>
              <ViewRounds />
            </ProtectedRoute>
          }
        />
        <Route
          path="/paymentStatus"
          element={
            <ProtectedRoute requiredRoles={["admin"]}>
              <CheckPaymentStatus />
            </ProtectedRoute>
          }
        />
        <Route
          path="/withdrawals"
          element={
            <ProtectedRoute requiredRoles={["admin"]}>
              <Withdrawals />
            </ProtectedRoute>
          }
        />
        <Route
          path="/updatestatus"
          element={
            <ProtectedRoute requiredRoles={["admin"]}>
              <UpdateStatus />
            </ProtectedRoute>
          }
        />
        {/* Student Routes Wrapped in Progress Provider */}
        <Route
          path="/*"
          element={
            <StudentProgressProvider>
              <Routes>
                <Route
                  path="/personaldetails"
                  element={
                    <ProtectedRoute requiredRoles={["student"]}>
                      <DriveProtectedRoute>
                        <PersonalDetails />
                      </DriveProtectedRoute>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/parentdetails"
                  element={
                    <ProtectedRoute requiredRoles={["student"]}>
                      <DriveProtectedRoute>
                        <ParentDetails />
                      </DriveProtectedRoute>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/educationdetails"
                  element={
                    <ProtectedRoute requiredRoles={["student"]}>
                      <DriveProtectedRoute>
                        <EducationDetails />
                      </DriveProtectedRoute>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/collegedetails"
                  element={
                    <ProtectedRoute requiredRoles={["student"]}>
                      <DriveProtectedRoute>
                        <CollegeDetails />
                      </DriveProtectedRoute>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/examdetails"
                  element={
                    <ProtectedRoute requiredRoles={["student"]}>
                      <DriveProtectedRoute>
                        <ExamDetails />
                      </DriveProtectedRoute>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/jeeupdate"
                  element={
                    <ProtectedRoute requiredRoles={["student"]}>
                      <DriveProtectedRoute>
                        <JeeUpdate />
                      </DriveProtectedRoute>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/withdrawal"
                  element={
                    <ProtectedRoute requiredRoles={["student"]}>
                      <WithdrawApplication />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/programmedetails"
                  element={
                    <ProtectedRoute requiredRoles={["student"]}>
                      <DriveProtectedRoute>
                        <Programmepreference />
                      </DriveProtectedRoute>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/applicant/home"
                  element={
                    <ProtectedRoute requiredRoles={["student"]}>
                      <StudentHome />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/query/:id"
                  element={
                    <ProtectedRoute>
                      <QueryChatPopup />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/allQueries"
                  element={
                    <ProtectedRoute>
                      <AllQueriesPopup />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/newQuery"
                  element={
                    <ProtectedRoute>
                      <HelpQueryPopup />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/myQuery"
                  element={
                    <ProtectedRoute>
                      <MyQueriesPopup />
                    </ProtectedRoute>
                  }
                />
                {/* <Route
                  path="/applicant/home"
                  element={
                    <ProtectedRoute requiredRoles={["student"]}>
                      <StudentRegistrationHome />
                    </ProtectedRoute>
                  }
                /> */}
                <Route
                  path="/paymentinitiate"
                  element={
                    <ProtectedRoute requiredRoles={["student"]}>
                      <DriveProtectedRoute>
                        <PaymentInitiate />
                      </DriveProtectedRoute>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/payment-status"
                  element={
                    <ProtectedRoute requiredRoles={["student"]}>
                      <PaymentStatus />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/icici-payment-status"
                  element={
                    <ProtectedRoute requiredRoles={["student"]}>
                      <PaymentIciciStatus />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/declaration"
                  element={
                    <ProtectedRoute requiredRoles={["student"]}>
                      <Declaration />
                    </ProtectedRoute>
                  }
                />
                <Route path="/unauthorized" element={<Unauthorized />} />
                <Route path="*" element={<NotFound />} />
                <Route
                  path="/onlineRound/:appId"
                  element={
                    <ProtectedRoute requiredRoles={["student", "admin"]}>
                      <BtechOnlineRound />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/mtech-online-display/:appId"
                  element={
                    <ProtectedRoute requiredRoles={["student", "admin"]}>
                      <MtechOnlineRoundDisplay />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/btech-online-display/:appId"
                  element={
                    <ProtectedRoute requiredRoles={["student", "admin"]}>
                      <BtechOnlineRoundDisplay />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </StudentProgressProvider>
          }
        />
        /
      </Routes>
    </>
  );
}

export default App;
